import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss';
import registerServiceWorker from './registerServiceWorker';
import * as ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

const pixelOptions = {
  autoConfig: true,
  debug: false
};

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);
ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL, pixelOptions);

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js